<template>
    <div>
        <span class="body-2 mx-2 pt-1">{{ $t('lang.helpful') }}:</span>
        <bc-tooltip top>
            <template slot="activator">
                <v-btn flat icon :color="feedback != null && feedback ? 'green' : null" @mouseup.left="feedbackResponse(true)">
                    <v-icon
                        :class="{ 'material-icons-outlined' : feedback == null || !feedback }"
                        :color="feedback == null || !feedback ? 'green' : null"
                    >
                        thumb_up
                    </v-icon>
                </v-btn>
            </template>
            {{ $t('lang.yes_helpful') }}
        </bc-tooltip>
        <v-divider vertical class="mx-2"></v-divider>
        <bc-tooltip top>
            <template slot="activator">
                <v-btn flat icon :color="feedback != null && !feedback ? 'red' : null" @mouseup.left="feedbackResponse(false)">
                    <v-icon
                        :class="{ 'material-icons-outlined' : feedback == null || feedback == true }"
                        :color="feedback == null || feedback ? 'red' : null"
                    >
                        thumb_down
                    </v-icon>
                </v-btn>
            </template>
            {{ $t('lang.no_helpful') }}
        </bc-tooltip>
    </div>
</template>

<script>
export default {
    data() {
        return {
            feedback: null
        }
    },
    methods: {
        feedbackResponse(response){
            this.feedback = response;
        }
    }
};
</script>